import { jsx } from 'react/jsx-runtime';
import { tailwind } from '@circlefin/tailwind';
import classNames from 'classnames';
import { FilterActionButton } from './ActionButton/ActionButton.es.js';
import { FiltersContextProvider } from './Context/TableFilters.Context.es.js';
import { FilterDateRange } from './DateRange/DateRange.es.js';
import { FilterDropdown } from './Dropdown/Dropdown.es.js';
import { FilterInput } from './Input/Input.es.js';
import { FilterMultiSelectDropdown } from './MultiSelectDropdown/MultiSelectDropdown.es.js';

/**
 * Filters Sub-component of TableCard.
 */ const TableFilters = ({ size = 0, className, children, ...providerProps })=>jsx(FiltersContextProvider, {
        ...providerProps,
        children: jsx("div", {
            className: classNames('grid gap-6', className, tailwind.gridCols(size)),
            "data-testid": "table-filters",
            children: children
        })
    });
TableFilters.displayName = 'TableCard.Filters';
TableFilters.DateRange = FilterDateRange;
TableFilters.Dropdown = FilterDropdown;
TableFilters.Input = FilterInput;
TableFilters.MultiSelectDropdown = FilterMultiSelectDropdown;
TableFilters.ActionButton = FilterActionButton;

export { TableFilters, TableFilters as default };
//# sourceMappingURL=TableFilters.es.js.map
